import React from 'react'
import Link from 'gatsby-link'
import Layout from '../components/layout'
import { graphql } from 'gatsby'
import SEO from "../components/seo"
import BlogHeader from '../components/blogHeader'

const BlogPage = ({ data }) => (
    <Layout>
      <SEO title="Blog" />
        <div>
          <BlogHeader
            HeaderTitle="Latest Posts"
            HeaderDesc="Find information about my latest work and passion" 
          />
          <div className="py-12">
            {data.allMarkdownRemark.edges.map(post => (
            <div key={post.node.id} className="blog-container">
              <div className="px-8 py-6 mb-8 text-white rounded md:mx-0 bg-gradient-alt md:flex-row">
                <div>
                  <Link to={`/blog${post.node.fields.slug}`}>
                  <h1 className="text-4xl font-extrabold">{post.node.frontmatter.title}</h1>
                  <p className="py-1 text-base">{post.node.excerpt}</p>
                  <small>
                    Posted by on {post.node.frontmatter.date}
                  </small>
                  </Link>
                  <br />
                  <Link to={`/blog${post.node.fields.slug}`} className="inline-block text-center btn-cta md:text-left">Read More</Link>
                </div>
              </div>
            </div>
            ))}
          </div>
        </div>
    </Layout>
)

export const pageQuery = graphql`
  query BlogIndexQuery {
    allMarkdownRemark (sort: { fields: [frontmatter___date, frontmatter___title] order: DESC}) {
      edges {
        node {
          excerpt(pruneLength: 175)
          id
          frontmatter {
            title
            date
            featured {
              childImageSharp {
                fluid(maxWidth: 720, quality: 85) {
                ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`

export default BlogPage